export const HTTP_DEFAULT_TIMEOUT_MS = 15_000;
export const PROCESS_EXEC_TIMEOUT_MS = 30_000;
export const PROCESS_MAX_BUFFER_BYTES = 10 * 1024 * 1024;
export const DEFAULT_SERVER_PORT = 3_000;
export const ERROR_PREVIEW_MAX_CHARS = 300;
export const JSON_PRETTY_INDENT = 2;
export const MCP_HTTP_PATH = "/mcp";
export const MCP_HEALTH_PATH = "/health";
export const MCP_TRANSPORT_HTTP = "http";
export const MCP_TRANSPORT_STDIO = "stdio";
export const MCP_TRANSPORT_DEFAULT = MCP_TRANSPORT_HTTP;
export const MCP_TRANSPORT_SUPPORTED = [MCP_TRANSPORT_HTTP, MCP_TRANSPORT_STDIO] as const;

export const DEFAULT_USER_AGENT =
  "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/132.0.0.0 Safari/537.36";

export const WRITEUP_SEARCH_DEFAULT_LIMIT = 5;
export const WRITEUP_SEARCH_MAX_LIMIT = 20;
export const DOMAIN_LIST_DEFAULT_LIMIT = 30;
export const DOMAIN_LIST_MAX_LIMIT = 100;
export const DUCKDUCKGO_DEFAULT_LIMIT = 10;
export const DUCKDUCKGO_MAX_LIMIT = 50;
export const DUCKDUCKGO_API_TIMEOUT_MS = 20_000;

export const YANDEX_IMAGE_TIMEOUT_MS = 25_000;
export const YANDEX_IMAGE_DEFAULT_LIMIT = 20;
export const YANDEX_IMAGE_MAX_LIMIT = 50;

export const ARCHIVE_TIMEOUT_MS = 25_000;
export const ARCHIVE_DEFAULT_LIMIT = 50;
export const ARCHIVE_MAX_LIMIT = 200;

export const DOMAIN_RECON_DEFAULT_CERT_LIMIT = 50;
export const DOMAIN_RECON_MAX_CERT_LIMIT = 200;
export const DOMAIN_RECON_CRTSH_NON_JSON_PREVIEW_MAX_CHARS = 200;
export const DOMAIN_RECON_CRTSH_SAMPLE_MAX_ROWS = 20;
export const DOMAIN_RECON_WHOIS_PREVIEW_MAX_CHARS = 12_000;

export const MEDIA_DEFAULT_MAX_DOWNLOAD_BYTES = 25_000_000;
export const MEDIA_MIN_MAX_DOWNLOAD_BYTES = 100_000;
export const MEDIA_MAX_MAX_DOWNLOAD_BYTES = 100_000_000;
export const MEDIA_DEFAULT_DOWNLOAD_TIMEOUT_MS = 30_000;
export const MEDIA_MIN_DOWNLOAD_TIMEOUT_MS = 5_000;
export const MEDIA_MAX_DOWNLOAD_TIMEOUT_MS = 120_000;

export const WAYBACK_TIMEOUT_MS = 60_000;
export const WAYBACK_MIN_TIMEOUT_MS = 5_000;
export const WAYBACK_MAX_TIMEOUT_MS = 120_000;
export const WAYBACK_RETRY_COUNT = 2;
export const WAYBACK_RETRY_BACKOFF_MS = 1_200;
export const WAYBACK_DEFAULT_LIMIT = 20;
export const WAYBACK_MAX_LIMIT = 100;

export const JINA_TIMEOUT_MS = 25_000;
export const JINA_DEFAULT_MAX_CHARS = 5_000;
export const JINA_MIN_MAX_CHARS = 200;
export const JINA_MAX_MAX_CHARS = 20_000;

export const TWSTALKER_TIMEOUT_MS = 25_000;
export const TWSTALKER_DEFAULT_LIMIT = 20;
export const TWSTALKER_MAX_LIMIT = 80;

export const CAPSOLVER_TIMEOUT_MS = 20_000;
export const CAPSOLVER_DEFAULT_POLL_TIMEOUT_MS = 60_000;
export const CAPSOLVER_MIN_POLL_TIMEOUT_MS = 5_000;
export const CAPSOLVER_MAX_POLL_TIMEOUT_MS = 120_000;
export const CAPSOLVER_DEFAULT_POLL_INTERVAL_MS = 1_500;
export const CAPSOLVER_MIN_POLL_INTERVAL_MS = 500;
export const CAPSOLVER_MAX_POLL_INTERVAL_MS = 10_000;
